import React, { Component } from 'react';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as webAppointmentActions from '../../actions/webAppointmentActions';
import { nextPage } from '../../functions/nextPage';
import * as defaultState from '../../constants/DefaultState';
import { dropDownDefault } from '../../constants/webAppointmentConstants';
import apiGet from '../../../shared/functions/apiGet';
import apiPost from '../../../shared/functions/apiPost';

export class AppointmentPreferencesPage extends Component {
  // Set the list of specialties and departments to a reasonable default,
  // just in case the API call doesn't work.
  specialtiesAndDepartments = [
    { name: dropDownDefault, value: undefined },
    { value: '6089AB2E-5F33-49E3-B1F1-5D4B8E9A01A6', name: 'Brain Tumor & Neuro-Oncology' },
    { value: '9B5B51AA-8DDA-4C79-B683-4EFF784A44DF', name: 'Dementia & Memory Decline' },
    { value: 'CE901088-5837-4B03-9B48-211971307C28', name: 'Epilepsy & Seizures' },
    { value: 'ECA3733A-27B3-4721-A454-67B25E3C815E', name: 'General Neurology' },
    { value: '5E103185-BFAB-43B4-8CC6-3BC4678BACF8', name: 'Headache & Facial Pain' },
    { value: 'BB1FB06C-4D80-4302-938E-D15F83920AF0', name: 'Movement Disorders (Parkinson\'s disease & tremors)' },
    { value: '1E61F3A6-95BD-473A-9D11-DFCECF281CA3', name: 'Multiple Sclerosis' },
    { value: '2E2CBFDF-35A9-4237-84D6-4ABFEA6C2196', name: 'Orthopaedics' },
    { value: '8D2975BC-F60A-4D88-B0B1-E05CAC46ACE7', name: 'Physical & Occupational Therapy (adult)' },
    { value: 'A28F3693-0555-47BF-B0FC-D2616E4A94DA', name: 'Podiatry' },
    { value: 'A0DC3A78-D933-4B62-A8BC-916DC698F547', name: 'Psychiatry/Psychology (adult)' },
    { value: 'D6593011-014C-4F13-99E1-5AEE9F53E830', name: 'Psychiatry/Psychology (pediatric)' },
    { value: 'CD915B33-FAA3-43B4-9FDC-B1839A7305FF', name: 'Rheumatology' },
    { value: '21957237-2E80-49FB-923C-603F05D4E110', name: 'Sleep Medicine' },
    { value: '9E6388F6-C876-4FC1-A5A6-1CB687353DB9', name: 'Spine Health (back & neck pain)' },
    { value: 'C3399F62-7EE3-486D-B77F-7B144044BEDE', name: 'Sports Medicine' }
  ];

  locations = [{ name: dropDownDefault, value: undefined }];

  constructor(props) {
    super(props);
    this.state = {rerender: 1};
  }

  checkGuidFormat(guids) {
    guids.forEach((guid, index, array) => {
      if (typeof guid !== "string") {
        console.log("Element " + index + " of the department GUID array is not a string: " + guid);
        return
      }
      let g = guid;   // Make a temporary working copy of the GUID.
      if (!g.match(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/)) {
        g = g.replace(/[^0-9A-Fa-f]/g, '');
        if (g.length === 32) {
          g = g.substring(0, 8) + '-' + g.substring(8, 12) + '-' + g.substring(12, 16) + '-' + g.substring(16, 20) + '-' + g.substring(20, 32);
          console.log("Deprtment GUID " + guid + " is not correctly formatted but was updated to " + g);
          array[index] = g;
        }
        else {
          console.log("Deprtment GUID " + guid + " is not correctly formatted and is unfixable.");
        }
      }
    });
  }

  // API interfaces.

  getDepartments = () => {
    //https://my.clevelandclinic.org/api/sitecore/WebAppointment/GetDepartments
    // "data" should be a serialized array of department GUID strings.
    let data = null;
    if (!document.webappointmentReactParameters ||
      typeof document.webappointmentReactParameters !== "object" ||
      !document.webappointmentReactParameters["department-list"] ||
      typeof document.webappointmentReactParameters["department-list"] !== "object" ||
      !Array.isArray(document.webappointmentReactParameters["department-list"])) {
      console.log("The list of department GUIDs is not correctly specified.");
      return;
    }

    this.checkGuidFormat(document.webappointmentReactParameters["department-list"]);
    data = JSON.stringify(document.webappointmentReactParameters["department-list"]);
    return new Promise((resolve, reject) => {
      apiPost("/api/sitecore/WebAppointment/GetDepartments", data, null, true, "application/json", true)
        .then((depts) => {
          resolve(depts);
        })
        .catch((error) => {
          // make no changes if we error.
        });
    });
  }

  getLocationsForDepartment = (deptUid) => {
    //https://my.clevelandclinic.org/api/sitecore/WebAppointment/GetLocations?DepartmentUid=50616e5a-8fa5-4d85-890d-00f8cca5a3bd
    let options = { params: { DepartmentUid: deptUid } };
    return new Promise((resolve, reject) => {
      apiGet("/api/sitecore/webappointment/getlocations", options, null, null, null, false, false, true)
        .then((locations) => {
          resolve(locations);
        })
        .catch((error) => {
          // restore default if we error
          let locations = [];
          resolve(locations);
        });
    });
  }

  fillDepartments() {
    this.getDepartments()
      .then((depts) => {
        // process 'depts' - i.e. save locally so that render() can get to them.
        this.specialtiesAndDepartments = depts.data.map(l => {
          return { value: l.Value, name: l.Text };
        }).sort((d1, d2) => {
          return d1.name === d2.name ? 0 : d1.name < d2.name ? -1 : 1;
        });
        this.specialtiesAndDepartments.unshift({ name: dropDownDefault, value: undefined });

        // Tweak the state just enough to call render() again.
        this.setState((prevState) => { return { rerender: prevState.rerender + 1 }; });
      });
  }

  fillLocations(deptGuid) {
    if (this.props.appointment.department) {
      this.getLocationsForDepartment(deptGuid)
        .then((locations) => {
          // process 'locations' - i.e. save locally so that render() can get to them.
          this.locations = locations.map(l => {
            return { value: l.Value, name: l.Text };
          }).filter(l => !l.name.includes("Canada"));
          this.locations.unshift({ name: dropDownDefault, value: undefined });
          // Tweak the state just enough to call render() again.
          this.setState((prevState) => { return { rerender: prevState.rerender + 1 }; });
        });
    }
    else {
      this.locations = [{ name: dropDownDefault, value: undefined }];
      // Tweak the state just enough to call render() again.
      this.setState((prevState) => { return { rerender: prevState.rerender + 1 }; });
    }
  }

  // Lifecycle Methods:
  componentDidUpdate(prevProps, prevState) {
    // If the department changed, then reretrieve the list of locations.
    if (this.props.appointment.department !== prevProps.appointment.department) {
      this.fillLocations(this.props.appointment.department.split("|")[0])
    }
  }

  componentDidMount() {
    this.fillDepartments();
    if (this.props.appointment.department) {
      this.fillLocations(this.props.appointment.department.split("|")[0])
    }
  }

  isValid() {
    let valid = (
      this.props.appointment.department &&
      this.props.appointment.location
    );
    return !!valid;
  }

  render() {
    const title = "What are " + (this.props.forMe ? "your" : "their") + " appointment preferences?";
    const paragraph = "We’ll do our best to accommodate " + (this.props.forMe ? "your" : "their") + " visit preferences, but may not be able to meet all of " + (this.props.forMe ? "your" : "their") + " requests.";

    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        inputs: [
          {
            type: 'select',
            id: 'department',
            key: 'department-',
            label: 'Which specialty area or department best matches ' + (this.props.forMe ? "your" : "their") + ' need?',
            required: true,
            requiredError: "Please enter a specialty area of department.",
            validateOnBlur: true,
            validationErrorClass: "web-appointment__error",
            onChange: (value) => {
              let selectedOption = this.specialtiesAndDepartments.find(d => d.value === value);
              if (!selectedOption) {
                selectedOption = this.specialtiesAndDepartments[0];
                value = undefined;
              }
              // Find the first (and only, I would hope) department with that GUID.
              let deptName = selectedOption.name;
              this.props.webAppointmentSetAppointmentDepartment(value ? (value + "|" + deptName) : "");
            },
            helperText: "This helps us identify the right provider for the appointment.",
            existingContent: this.props.appointment.department ? this.props.appointment.department.split("|")[0] : undefined,
            options: this.specialtiesAndDepartments
          },
          {
            type: 'select',
            id: 'location',
            key: 'location-' + Math.random(),
            label: "Choose a location that’s convenient for " + (this.props.forMe ? "you" : "them") + ".",
            required: true,
            requiredError: "Please choose a location.",
            validateOnBlur: true,
            validationErrorClass: "web-appointment__error",
            helperText: "These locations have the specialty selected above.",
            onChange: (value) => {
              let selectedOption = this.locations.find(l => l.value === value);
              if (!selectedOption) {
                selectedOption = this.locations[0];
                value = undefined;
              }
              // Find the first (and only, I would hope) location with that GUID.
              let locName = selectedOption.name;
              this.props.webAppointmentSetAppointmentLocation(value ? (value + "|" + locName) : "");
            },
            existingContent: this.props.appointment.location ? this.props.appointment.location.split("|")[0] : undefined,
            options: this.locations
          },
        ],
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order",
        inputs: [
          [
            {
              type: 'button',
              id: "back",
              className: "btn--secondary",
              value: 'Back',
              onClick: () => {
                this.props.history.goBack();
              }
            },
            {
              type: 'button',
              id: "next",
              className: "btn--primary",
              value: "Next",
              disabled: !this.isValid(),
              onClick: () => {
                this.props.history.push(nextPage());
              }
            }
          ]
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className='web-appt__header'>
              <h1>{title}</h1>
              <p>{paragraph}</p>
              <hr />
            </div>
          </GridItem>
        </Grid>
        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

AppointmentPreferencesPage.propTypes = {
  webAppointmentSetAppointmentDepartment: PropTypes.func.isRequired,
  webAppointmentSetAppointmentLocation: PropTypes.func.isRequired,
  appointment: defaultState.appointmentProptype,
  forMe: PropTypes.bool.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    appointment: state.webAppointmentForm.appointment,
    forMe: state.webAppointmentForm.forMe
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentSetAppointmentDepartment: (value) => dispatch(webAppointmentActions.webAppointmentSetAppointmentDepartment(value)),
    webAppointmentSetAppointmentLocation: (value) => dispatch(webAppointmentActions.webAppointmentSetAppointmentLocation(value)),
  };
};

// connects component to redux, and passes along the router
export default connect(mapStateToProps, mapDispatchToProps)(AppointmentPreferencesPage);
